<template>
  <div class="compressed-content">
    <h3 class="page-question">Have you had diabetes during pregnancy (often called gestational diabetes)?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.pregnancyDiabetStatus">
      <b-form-radio v-model="survey.pregnancyDiabetStatus" name="pregnancy" :value=pregnancyDiabetType.Yes>Yes</b-form-radio>
      <b-form-radio v-model="survey.pregnancyDiabetStatus" name="pregnancy" :value=pregnancyDiabetType.No>No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import pregnancyDiabetType from "enums/pregnancy-diabet-type";
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    data() {
      return {
        pregnancyDiabetType: pregnancyDiabetType,
      };
    },

    validations: {
      pregnancyDiabetStatus: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      pregnancyDiabetStatus() { return this.survey.pregnancyDiabetStatus }
    }
  };
</script>